import { service } from '@ember/service';
import Route from '@ember/routing/route';
import type ReimaginedDataService from 'tio-employee/services/reimagined-data';

export default class AuthenticatedCareerPathwaysSkillsGapsRoute extends Route {
  @service declare reimaginedData: ReimaginedDataService;

  async model() {
    const [skillGaps, skillsData] = await Promise.all([
      this.reimaginedData.fetchSkillGaps(),
      this.reimaginedData.fetchEmployeeSkills(),
    ]);

    return {
      skillGaps,
      summary: skillsData.summary,
    };
  }
}
